import { AppRoutes } from '@app/AppRoutes'

export const Startup = () => <AppRoutes />
